import { gql } from "@apollo/client"

const ASSET_TYPE_FIELDS = gql`
  fragment AssetTypeFields on AssetType {
    id
    name
    uploads {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    customFields {
      ... on BooleanCustomField {
        id
        name
        defaultValueBoolean: defaultValue
      }
      ... on StringCustomField {
        id
        name
        defaultValueString: defaultValue
        possibleValues
      }
      ... on NumberCustomField {
        id
        name
        defaultValueNumber: defaultValue
        minimumValue
        maximumValue
        unit
      }
      ... on DateCustomField {
        id
        name
        defaultValueDate: defaultValue
      }
    }
  }
`

export { ASSET_TYPE_FIELDS }
